import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";
import { ArrowUp, ArrowDown, Minus } from "lucide-react";

const TICK_STYLE = { fontSize: 11 };
const BAR_RADIUS = [0, 4, 4, 0];
const BAR_MARGIN = { left: 10, right: 10 };

export function TrendBadge({ trend, invertGood }) {
  if (!trend) return null;
  const isFlat = trend.direction === "flat" || trend.pct === 0;
  const isUp = trend.direction === "up";
  const good = invertGood ? !isUp : isUp;

  let color;
  if (isFlat) color = "#6b7280";
  else if (good) color = "#059669";
  else color = "#dc2626";

  let Icon;
  if (isFlat) Icon = Minus;
  else if (isUp) Icon = ArrowUp;
  else Icon = ArrowDown;

  return (
    <span className="ddf-trend-badge" style={{ color }} data-testid={`trend-${trend.direction}`}>
      <Icon size={12} />
      {trend.pct.toFixed(1)}%
    </span>
  );
}

export function MetricCard({ icon: Icon, label, value, sub, trend, invertGood, testid, lastUpdated }) {
  return (
    <div className="ddf-an-metric" data-testid={testid}>
      <div className="ddf-an-metric-head">
        <Icon size={16} className="ddf-an-metric-icon" />
        <span className="ddf-an-metric-label">{label}</span>
      </div>
      <div className="ddf-an-metric-value">{value}</div>
      {sub && <div className="ddf-an-metric-sub">{sub}</div>}
      <TrendBadge trend={trend} invertGood={invertGood} />
      {lastUpdated && (
        <div className="ddf-an-metric-stamp" title={lastUpdated}>
          Last updated {lastUpdated}
        </div>
      )}
    </div>
  );
}

// Horizontal ranked bar chart used for promo-click breakdowns.
export function RankedBarChart({ title, testid, rows, color, emptyText }) {
  const items = rows || [];
  return (
    <section className="ddf-an-chart-card" data-testid={testid}>
      <h4 className="ddf-an-chart-title">{title}</h4>
      <div className="ddf-an-chart-body">
        {items.length === 0 ? (
          <div className="ddf-an-empty">{emptyText}</div>
        ) : (
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={items.slice(0, 10)} layout="vertical" margin={BAR_MARGIN}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
              <XAxis type="number" tick={TICK_STYLE} allowDecimals={false} />
              <YAxis dataKey="name" type="category" tick={TICK_STYLE} width={140} tickFormatter={(v) => (String(v).length > 34 ? `${String(v).slice(0, 33)}…` : v)} />
              <Tooltip />
              <Bar dataKey="count" fill={color} radius={BAR_RADIUS} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </section>
  );
}
